export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
} 

// Добавляем новую функцию для форматирования чисел
export function formatNum(value, decimals = 2, placeholder = 'N/A') {
  const num = Number(value);
  if (typeof value === 'number' && !isNaN(num)) {
      return num.toFixed(decimals);
  }
  return placeholder;
}

/**
 * Генерирует постоянный смешной никнейм на основе ID пользователя.
 * @param {string|number} userId - ID пользователя
 * @param {Array<string>} nicknames - Массив доступных никнеймов из локализации
 * @returns {string} Выбранный никнейм или фоллбэк
 */
export function getFunnyNickname(userId, nicknames = []) {
  const safeId = String(userId || '0');

  if (!nicknames || !Array.isArray(nicknames) || nicknames.length === 0) {
    return `User ${safeId.slice(-4)}`;
  }

  // Простой хеш-алгоритм (djb2 или аналогичный для детерминизма)
  let hash = 0;
  for (let i = 0; i < safeId.length; i++) {
    const char = safeId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32bit integer
  }

  // Получаем положительный индекс
  const index = Math.abs(hash) % nicknames.length;

  return nicknames[index];
}